/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";

// ─── Renk Paleti ─────────────────────────────────────────────────────────────
const C = {
    bg:      "#0f172a",
    panel:   "#1e293b",
    border:  "#334155",
    text:    "#e2e8f0",
    muted:   "#94a3b8",
    accent:  "#3b82f6",
    bullish: "#16a34a",
    bearish: "#dc2626",
    warning: "#f59e0b",
    gold:    "#eab308",
    purple:  "#7c3aed",
    teal:    "#0d9488",
    orange:  "#ea580c",
};

async function getToken() {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;
    if (session.expires_at * 1000 - Date.now() < 5 * 60 * 1000) {
        const { data } = await supabase.auth.refreshSession();
        return data.session?.access_token;
    }
    return session.access_token;
}

function riskRenk(skor) {
    if (skor == null) return C.muted;
    if (skor <= 20)  return C.bullish;
    if (skor <= 40)  return "#22c55e";
    if (skor <= 60)  return C.gold;
    if (skor <= 80)  return C.orange;
    return C.bearish;
}

function riskEtiket(skor) {
    if (skor == null) return "—";
    if (skor <= 20)  return "Çok Düşük";
    if (skor <= 40)  return "Düşük";
    if (skor <= 60)  return "Orta";
    if (skor <= 80)  return "Yüksek";
    return "Çok Yüksek";
}

function etki2Renk(etki) {
    if (etki == null) return C.muted;
    if (etki > 0)    return C.bullish;
    if (etki < -7)   return C.bearish;
    if (etki < 0)    return C.orange;
    return C.muted;
}

function formatSure(sn) {
    if (sn == null || sn < 0) return "—";
    const h = Math.floor(sn / 3600);
    const m = Math.floor((sn % 3600) / 60);
    const s = sn % 60;
    if (h > 0) return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
    return `${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
}


// ─── Bilgi İçerikleri ────────────────────────────────────────────────────────
const BILGI_ICERIK = {
    drawdown: {
        baslik: "Drawdown",
        aciklama: "Portföyün tarihi en yüksek değerinden (high-water mark) mevcut değere düşüş yüzdesi. %10 uyarı eşiği, %20 veto eşiği. Veto eşiği aşılırsa yeni risk sinyali üretilmez.",
    },
    kalite: {
        baslik: "Kalite Skoru",
        aciklama: "Birleşik Skor'a girmeden önce ham sinyal kalitesini ölçen Katman-1 skoru (0-100). Likidite yetersizliği -40, aşırı volatilite -30, makro veto -60 ceza uygular. 50 altı kalite filtreden geçemez.",
    },
    makro_veto: {
        baslik: "Makro Veto",
        aciklama: "Piyasa Rejim Skoru < 25 VE Haber Duygu Skoru < 25 olduğunda otomatik devreye girer. İkisi birden olumsuzsa sinyal tamamen durdurulur. Yalnızca biri olumsuzsa sadece ceza puan uygulanır.",
    },
    risk_skoru: {
        baslik: "Risk Skoru",
        aciklama: "6 bileşenin ağırlıklı ortalaması (0-100). Düşük = az risk = iyi. ≤20: Çok Düşük risk (+5 puan bonus), ≤40: Düşük (+2), ≤50: Nötr (0), ≤70: Yüksek (-5), ≤85: Çok Yüksek (-10), >85: Kritik (-15 puan).",
    },
    risk_seviyesi: {
        baslik: "Risk Seviyesi",
        aciklama: "Risk Skoru'na göre belirlenen etiket: Çok Düşük (≤20), Düşük (≤40), Orta (≤60), Yüksek (≤80), Çok Yüksek (>80). Birleşik Skor üzerindeki bonus/ceza puanı bu seviyeye göre hesaplanır.",
    },
    etki: {
        baslik: "Birleşik Skor Etkisi",
        aciklama: "Risk Filtresinin Birleşik Skor'a uyguladığı düzeltme (−15 ile +5 arası). Düşük risk → bonus puan, yüksek risk → ceza puan. Final Konfidans = Birleşik Skor + Risk Etkisi formülüyle hesaplanır.",
    },
    volatilite_atr: {
        baslik: "Volatilite ATR%",
        aciklama: "Son 14 günlük Average True Range değerinin kapanış fiyatına oranı (%). BIST için >%8 aşırı riskli sayılır, Kripto için eşik %15'tir. %4 üzerinde kademeli ceza başlar. Yüksek ATR = daha geniş stop-loss gerektirir.",
    },
    volatilite: {
        baslik: "Volatilite Puanı",
        aciklama: "ATR% değerinin maksimum eşiğe oranlanmasıyla elde edilen risk puanı (0-100). Risk Skoru hesabında %25 ağırlık taşır. 100'e yakın = son derece oynak sembol.",
    },
    korelasyon: {
        baslik: "Korelasyon Puanı",
        aciklama: "Sembolün portföydeki mevcut açık pozisyonlarla son 60 günlük fiyat hareketi korelasyonu (0-100). 0.75 üzeri yüksek korelasyon elenme sebebidir. Portföyde pozisyon yoksa 0 döner. Risk Skoru'nda %20 ağırlık.",
    },
    likidite: {
        baslik: "Likidite Puanı",
        aciklama: "Günlük ortalama işlem hacminin BIST için 5M TL, Kripto için 500K USD eşiğine göre değerlendirilmesi (0-100). Eşiğin altında kalite filtresi -40 puan uygular. Risk Skoru'nda %20 ağırlık.",
    },
    sektor_yogunluk: {
        baslik: "Sektör Yoğunluk Puanı",
        aciklama: "Portföyde aynı sektörden kaç pozisyon açık olduğunu ölçer. Max 3 pozisyon veya portföyün %30'u tek sektörde olursa elenme sebebidir. Risk Skoru'nda %15 ağırlık taşır.",
    },
    makro_risk: {
        baslik: "Makro Risk Puanı",
        aciklama: "Piyasa Rejim Skoru ve Haber Duygu Skoru'nun 50 referans noktasından ne kadar saptığını ölçer (0-100). İkisi de 50 altındaysa maksimum makro risk puanı alınır. Risk Skoru'nda %10 ağırlık.",
    },
    risk_analizi_sekme: {
        baslik: "Risk Analizi",
        aciklama: "Risk Filtresi taramasının sembol bazlı sonuç listesi. Her sembol için Kalite Skoru (Katman-1), Makro Veto durumu, Risk Skoru (Katman-2) ve nihai Durum (Geçti/Elendi) burada listelenir. Bir sembole tıklayarak (Detay) tüm risk bileşenlerinin dökümünü görebilirsin.",
    },
};

function BilgiIkonu({ karti }) {
    const [acik, setAcik] = useState(false);
    const bilgi = BILGI_ICERIK[karti];
    if (!bilgi) return null;
    return (
        <span
            onMouseEnter={e => { e.stopPropagation(); setAcik(true); }}
            onMouseLeave={e => { e.stopPropagation(); setAcik(false); }}
            onClick={e => e.stopPropagation()}
            style={{
                position: "relative", marginLeft: 4, fontSize: 11, color: C.muted, cursor: "help",
                borderRadius: "50%", border: `1px solid ${C.border}`,
                padding: "0 4px", lineHeight: "16px", display: "inline-block",
                userSelect: "none",
            }}>
            ℹ
            {acik && (
                <div style={{
                    position: "absolute", top: "calc(100% + 8px)", left: "50%", transform: "translateX(-50%)",
                    background: C.panel, border: `1px solid ${C.border}`, borderRadius: 8,
                    padding: "10px 12px", width: 260, boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                    zIndex: 1000, textAlign: "left", whiteSpace: "normal", fontWeight: 400,
                }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: C.text, marginBottom: 4 }}>{bilgi.baslik}</div>
                    <div style={{ fontSize: 11, color: C.muted, lineHeight: 1.6 }}>{bilgi.aciklama}</div>
                </div>
            )}
        </span>
    );
}

// ─── Mini Çubuk ───────────────────────────────────────────────────────────────
function MiniBar({ deger = 0, max = 100, renk }) {
    const pct = Math.min(Math.max((deger / max) * 100, 0), 100);
    return (
        <div style={{ flex: 1, height: 6, background: "#0f172a", borderRadius: 3, overflow: "hidden", border: `1px solid ${C.border}` }}>
            <div style={{ height: "100%", width: `${pct}%`, background: renk, borderRadius: 3, transition: "width 0.4s" }} />
        </div>
    );
}

// ─── Risk Tarama İlerleme Paneli ─────────────────────────────────────────────
function RiskTaramaIlerlemePaneli({ durum, gecenSure, mod }) {
    const ilerleme   = durum.ilerleme   || 0;
    const mesaj      = durum.mesaj      || "";
    const gecen      = gecenSure        || 0;  // saniye saniye güncellenen state
    const tamamlanan = durum.tamamlanan || 0;
    const toplam     = durum.toplam     || 0;

    // "i/toplam|sembol" formatından parse et
    const parcalar    = mesaj.split("|");
    const aktifSembol = parcalar.length === 2 ? parcalar[1] : "";
    const gercekTam   = parcalar.length === 2 ? parseInt(parcalar[0]?.split("/")[0]) || tamamlanan : tamamlanan;
    const gercekTop   = parcalar.length === 2 ? parseInt(parcalar[0]?.split("/")[1]) || toplam     : toplam;

    const tahminiKalan = gercekTam > 0 && gecen > 0 && gercekTop > 0
        ? Math.round((gecen / gercekTam) * (gercekTop - gercekTam))
        : null;

    return (
        <div style={{
            marginBottom: 20, background: C.panel,
            border: `2px solid ${C.bearish}44`, borderRadius: 12, padding: 20,
            boxShadow: `0 0 20px ${C.bearish}18`,
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <span style={{ fontSize: 20 }}>🛡️</span>
                <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>
                    Risk Filtresi Taraması — {mod}
                </span>
                <span style={{ marginLeft: "auto", fontSize: 22, fontWeight: 800, color: C.bearish }}>
                    %{ilerleme}
                </span>
            </div>

            {/* İlerleme Çubuğu */}
            <div style={{ height: 10, background: C.bg, borderRadius: 6, overflow: "hidden", marginBottom: 10, border: `1px solid ${C.border}` }}>
                <div style={{
                    height: "100%", width: `${ilerleme}%`,
                    background: `linear-gradient(90deg, ${C.bearish}, ${C.orange})`,
                    borderRadius: 6, transition: "width 0.5s ease",
                }} />
            </div>

            {/* Aktif Sembol */}
            <div style={{ fontSize: 13, color: C.muted, marginBottom: 14, minHeight: 18 }}>
                {aktifSembol
                    ? <span>Analiz edilen: <strong style={{ color: C.text }}>{aktifSembol}</strong></span>
                    : <span>Başlatılıyor...</span>
                }
            </div>

            {/* Metrikler */}
            <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>TAMAMLANAN</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.accent }}>
                        {gercekTam.toLocaleString("tr-TR")} / {gercekTop.toLocaleString("tr-TR")}
                    </div>
                </div>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>GEÇEN SÜRE</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.teal }}>{formatSure(gecen)}</div>
                </div>
                <div>
                    <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>TAHMİNİ KALAN</div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: C.gold }}>
                        {tahminiKalan != null ? formatSure(tahminiKalan) : (gercekTam === 0 ? "Hesaplanıyor..." : "—")}
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── Puan Kartı ──────────────────────────────────────────────────────────────
function PuanKarti({ baslik, puan, ikon, renk, not, bilgi }) {
    return (
        <div style={{ background: C.bg, borderRadius: 8, padding: 12, border: `1px solid ${C.border}` }}>
            <div style={{ fontSize: 10, color: C.muted, fontWeight: 700, letterSpacing: "0.05em", marginBottom: 6, display: "flex", alignItems: "center" }}>
                <span>{ikon} {baslik}</span>
                {bilgi && <BilgiIkonu karti={bilgi} />}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <MiniBar deger={puan || 0} max={100} renk={renk} />
                <span style={{ color: renk, fontWeight: 700, fontSize: 14, minWidth: 32 }}>{puan != null ? (parseFloat(puan)||0).toFixed(0) : "—"}</span>
            </div>
            {not && <div style={{ fontSize: 10, color: C.muted, lineHeight: 1.4 }}>{not}</div>}
        </div>
    );
}

// ─── Pozisyon Formu ──────────────────────────────────────────────────────────
function PozisyonFormu({ mod, onKaydet, onIptal }) {
    const [form, setForm] = useState({
        symbol: "", sektor: "", yon: "ALIŞ",
        giris_fiyati: "", miktar: "",
        stop_fiyati: "", hedef_fiyati: "", notlar: ""
    });
    const [yukleniyor, setYukleniyor] = useState(false);
    const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
    const toplam = (parseFloat(form.giris_fiyati) || 0) * (parseFloat(form.miktar) || 0);

    async function kaydet() {
        if (!form.symbol || !form.giris_fiyati || !form.miktar) {
            toast.error("Sembol, giriş fiyatı ve miktar zorunlu."); return;
        }
        setYukleniyor(true);
        try {
            const token = await getToken();
            await axios.post(`${API_URL}/scan/portfoy/ekle`, {
                ...form,
                mod,
                symbol:       form.symbol.trim().toUpperCase(),
                giris_fiyati: parseFloat(form.giris_fiyati),
                miktar:       parseFloat(form.miktar),
                stop_fiyati:  form.stop_fiyati  ? parseFloat(form.stop_fiyati)  : null,
                hedef_fiyati: form.hedef_fiyati ? parseFloat(form.hedef_fiyati) : null,
                sektor:       form.sektor.trim() || null,
                notlar:       form.notlar.trim() || null,
            }, { headers: { Authorization: `Bearer ${token}` } });
            toast.success("Pozisyon eklendi.");
            onKaydet();
        } catch (e) {
            toast.error("Hata: " + (e.response?.data?.detail || e.message));
        } finally {
            setYukleniyor(false);
        }
    }

    const inp = (label, key, type = "text", placeholder = "") => (
        <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>{label}</div>
            <input
                type={type} value={form[key]} placeholder={placeholder}
                onChange={e => set(key, e.target.value)}
                style={{
                    width: "100%", padding: "7px 10px", borderRadius: 6, fontSize: 13,
                    background: C.bg, border: `1px solid ${C.border}`, color: C.text,
                    boxSizing: "border-box", outline: "none",
                }}
            />
        </div>
    );

    return (
        <div style={{
            background: C.panel, border: `1px solid ${C.accent}44`, borderRadius: 12,
            padding: 20, marginBottom: 20,
        }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 16 }}>
                ➕ Yeni Pozisyon Ekle — {mod}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
                {inp("Sembol *", "symbol", "text", "THYAO")}
                {inp("Sektör", "sektor", "text", "Ulaştırma")}
                <div>
                    <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>Yön *</div>
                    <div style={{ display: "flex", gap: 8 }}>
                        {["ALIŞ", "SATIŞ"].map(y => (
                            <button key={y} onClick={() => set("yon", y)} style={{
                                flex: 1, padding: "7px 0", borderRadius: 6, fontSize: 13, cursor: "pointer",
                                border: `1px solid ${form.yon === y ? (y === "ALIŞ" ? C.bullish : C.bearish) : C.border}`,
                                background: form.yon === y ? (y === "ALIŞ" ? C.bullish + "22" : C.bearish + "22") : "transparent",
                                color: form.yon === y ? (y === "ALIŞ" ? C.bullish : C.bearish) : C.muted,
                                fontWeight: 700,
                            }}>{y === "ALIŞ" ? "▲ ALIŞ" : "▼ SATIŞ"}</button>
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
                {inp("Giriş Fiyatı *", "giris_fiyati", "number", "0.00")}
                {inp("Miktar *", "miktar", "number", "100")}
                {inp("Stop Fiyatı", "stop_fiyati", "number", "0.00")}
                {inp("Hedef Fiyatı", "hedef_fiyati", "number", "0.00")}
            </div>
            {toplam > 0 && (
                <div style={{ fontSize: 12, color: C.gold, marginBottom: 12 }}>
                    Toplam Değer: {toplam.toLocaleString("tr-TR", { minimumFractionDigits: 2 })} {mod === "BIST" ? "TL" : "USD"}
                </div>
            )}
            {inp("Notlar", "notlar", "text", "İsteğe bağlı not...")}
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
                <button onClick={kaydet} disabled={yukleniyor} style={{
                    padding: "8px 24px", borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: "pointer",
                    background: yukleniyor ? C.border : "linear-gradient(135deg,#16a34a,#0d9488)",
                    border: "none", color: "white",
                }}>{yukleniyor ? "⏳ Kaydediliyor..." : "💾 Kaydet"}</button>
                <button onClick={onIptal} style={{
                    padding: "8px 20px", borderRadius: 8, fontSize: 14, cursor: "pointer",
                    background: "transparent", border: `1px solid ${C.border}`, color: C.muted,
                }}>İptal</button>
            </div>
        </div>
    );
}

// ─── Kapatma Popup ───────────────────────────────────────────────────────────
function KapatmaPopup({ pozisyon, onKapat, onIptal }) {
    const [fiyat, setFiyat] = useState("");
    const [yukleniyor, setYukleniyor] = useState(false);

    async function kapat() {
        if (!fiyat) { toast.error("Kapanış fiyatı girin."); return; }
        setYukleniyor(true);
        try {
            const token = await getToken();
            const res = await axios.post(
                `${API_URL}/scan/portfoy/${pozisyon.id}/kapat`,
                { kapanis_fiyati: parseFloat(fiyat) },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success(res.data.mesaj);
            onKapat();
        } catch (e) {
            toast.error("Hata: " + (e.response?.data?.detail || e.message));
        } finally {
            setYukleniyor(false);
        }
    }

    const kap = parseFloat(fiyat) || 0;
    const kz  = pozisyon.yon === "ALIŞ"
        ? (kap - pozisyon.giris_fiyati) * pozisyon.miktar
        : (pozisyon.giris_fiyati - kap) * pozisyon.miktar;
    const kzPct = pozisyon.giris_fiyati > 0
        ? (Math.abs(kap - pozisyon.giris_fiyati) / pozisyon.giris_fiyati * 100 * (kz >= 0 ? 1 : -1))
        : 0;

    return (
        <div style={{
            position: "fixed", inset: 0, zIndex: 999,
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "rgba(0,0,0,0.6)",
        }} onClick={onIptal}>
            <div style={{
                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14,
                padding: 28, width: 360, boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            }} onClick={e => e.stopPropagation()}>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.text, marginBottom: 16 }}>
                    Pozisyonu Kapat — {pozisyon.symbol}
                </div>
                <div style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>Kapanış Fiyatı</div>
                <input
                    type="number" value={fiyat} onChange={e => setFiyat(e.target.value)}
                    placeholder="0.00" autoFocus
                    style={{
                        width: "100%", padding: "8px 12px", borderRadius: 8, fontSize: 15,
                        background: C.bg, border: `1px solid ${C.accent}`, color: C.text,
                        boxSizing: "border-box", outline: "none", marginBottom: 12,
                    }}
                />
                {kap > 0 && (
                    <div style={{
                        background: (kz >= 0 ? C.bullish : C.bearish) + "22",
                        border: `1px solid ${(kz >= 0 ? C.bullish : C.bearish)}44`,
                        borderRadius: 8, padding: 12, marginBottom: 16,
                    }}>
                        <div style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>Tahmini K/Z</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: kz >= 0 ? C.bullish : C.bearish }}>
                            {kz >= 0 ? "+" : ""}{kz.toFixed(2)} ({kzPct >= 0 ? "+" : ""}{kzPct.toFixed(2)}%)
                        </div>
                    </div>
                )}
                <div style={{ display: "flex", gap: 10 }}>
                    <button onClick={kapat} disabled={yukleniyor} style={{
                        flex: 1, padding: "8px 0", borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: "pointer",
                        background: yukleniyor ? C.border : "linear-gradient(135deg,#dc2626,#ea580c)",
                        border: "none", color: "white",
                    }}>{yukleniyor ? "⏳..." : "Pozisyonu Kapat"}</button>
                    <button onClick={onIptal} style={{
                        padding: "8px 16px", borderRadius: 8, cursor: "pointer",
                        background: "transparent", border: `1px solid ${C.border}`, color: C.muted,
                    }}>İptal</button>
                </div>
            </div>
        </div>
    );
}

// ─── Risk Detay Popup ─────────────────────────────────────────────────────────
function RiskDetayPopup({ sonuc, onKapat }) {
    if (!sonuc) return null;
    const bilesenler = [
        { ad: "Volatilite",      puan: sonuc.volatilite_puan,           ikon: "📊", bilgi: "volatilite" },
        { ad: "Korelasyon",      puan: sonuc.korelasyon_puan,           ikon: "🔗", not: sonuc.korelasyon_not, bilgi: "korelasyon" },
        { ad: "Likidite",        puan: sonuc.likidite_puan,             ikon: "💧", bilgi: "likidite" },
        { ad: "Sektör Yoğunluk",puan: sonuc.sektor_konsantrasyon_puan, ikon: "🏭", not: sonuc.sektor_konsantrasyon_not, bilgi: "sektor_yogunluk" },
        { ad: "Makro Risk",      puan: sonuc.makro_risk_puan,           ikon: "🌍", bilgi: "makro_risk" },
        { ad: "Drawdown",        puan: sonuc.drawdown_puan,             ikon: "📉", not: sonuc.drawdown_not, bilgi: "drawdown" },
    ];
    const rr = riskRenk(sonuc.risk_skoru);

    return (
        <div style={{
            position: "fixed", inset: 0, zIndex: 999,
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "rgba(0,0,0,0.6)",
        }} onClick={onKapat}>
            <div style={{
                background: C.panel, border: `1px solid ${C.border}`, borderRadius: 14,
                padding: 28, maxWidth: 520, width: "92%", maxHeight: "85vh", overflowY: "auto",
                boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            }} onClick={e => e.stopPropagation()}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                    <div>
                        <div style={{ fontSize: 17, fontWeight: 700, color: C.text }}>{sonuc.symbol} — Risk Detayı</div>
                        <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{sonuc.mod}</div>
                    </div>
                    <button onClick={onKapat} style={{ background: "none", border: "none", color: C.muted, fontSize: 22, cursor: "pointer" }}>✕</button>
                </div>

                {/* Genel Skor */}
                <div style={{
                    background: rr + "22", border: `1px solid ${rr}44`,
                    borderRadius: 10, padding: 16, marginBottom: 20,
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                }}>
                    <div>
                        <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>GENEL RİSK SKORU</div>
                        <div style={{ fontSize: 28, fontWeight: 800, color: rr }}>{(parseFloat(sonuc.risk_skoru)||0).toFixed(1)}</div>
                        <div style={{ fontSize: 12, color: rr, fontWeight: 600 }}>{riskEtiket(sonuc.risk_skoru)} Risk</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>BİRLEŞİK SKOR ETKİSİ</div>
                        <div style={{ fontSize: 22, fontWeight: 800, color: etki2Renk(sonuc.final_risk_etki) }}>
                            {parseFloat(sonuc.final_risk_etki) > 0 ? "+" : ""}{(parseFloat(sonuc.final_risk_etki)||0).toFixed(1)} puan
                        </div>
                        <div style={{ fontSize: 11, color: sonuc.risk_gecti ? C.bullish : C.bearish, fontWeight: 700 }}>
                            {sonuc.risk_gecti ? "✓ Risk Filtresini Geçti" : "✗ Risk Filtresinde Elendi"}
                        </div>
                    </div>
                </div>

                {/* Katman-1 */}
                <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", marginBottom: 10 }}>
                    KATMAN 1 — HAM SİNYAL KALİTESİ <BilgiIkonu karti="kalite" />
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 20 }}>
                    <PuanKarti baslik="Kalite Skoru" puan={sonuc.kalite_skoru} ikon="⭐"
                        renk={sonuc.kalite_gecti ? C.bullish : C.bearish} not={sonuc.likidite_not} />
                    <PuanKarti baslik="Volatilite ATR%" puan={sonuc.volatilite_atr_pct} ikon="📊" max={20}
                        renk={sonuc.volatilite_ok ? C.bullish : C.bearish} not={sonuc.volatilite_not} />
                </div>
                {sonuc.makro_veto && (
                    <div style={{
                        background: C.bearish + "22", border: `1px solid ${C.bearish}44`,
                        borderRadius: 8, padding: 12, marginBottom: 16,
                    }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: C.bearish, marginBottom: 4 }}>🚫 MAKRO VETO</div>
                        <div style={{ fontSize: 12, color: C.muted }}>{sonuc.makro_veto_sebep}</div>
                    </div>
                )}

                {/* Katman-2 */}
                <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: "0.05em", marginBottom: 10 }}>
                    KATMAN 2 — PORTFÖY BAĞLAMI
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 16 }}>
                    {bilesenler.map(({ ad, puan, ikon, not, bilgi }) => (
                        <PuanKarti key={ad} baslik={ad} puan={puan} ikon={ikon}
                            renk={riskRenk(puan)} not={not}
                            bilgi={bilgi} />
                    ))}
                </div>

                {/* Elenme Sebebi */}
                {sonuc.elendi_sebep && (
                    <div style={{
                        background: C.bearish + "11", border: `1px solid ${C.bearish}33`,
                        borderRadius: 8, padding: 12,
                    }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: C.bearish, marginBottom: 6 }}>⛔ Elenme Sebebi</div>
                        {sonuc.elendi_sebep.split(" | ").map((s, i) => (
                            <div key={i} style={{ fontSize: 12, color: C.muted, marginBottom: 3 }}>• {s}</div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

// ─── Ana Bileşen ─────────────────────────────────────────────────────────────
export default function RiskDashboard() {
    const [mod,          setMod]          = useState("BIST");
    const [portfoy,      setPortfoy]      = useState(null);
    const [riskSonuclar, setRiskSonuclar] = useState(null);
    const [riskCalisiyor,setRiskCalisiyor]= useState(false);
    const [taramaDurum,  setTaramaDurum]  = useState(null);
    const [gecenSure,    setGecenSure]    = useState(0);
    const [formAcik,     setFormAcik]     = useState(false);
    const [kapatmaPopup, setKapatmaPopup] = useState(null);
    const [riskDetay,    setRiskDetay]    = useState(null);
    const [aktifSekme,   setAktifSekme]   = useState("portfoy");
    const [aramaMetni,   setAramaMetni]   = useState("");
    const [siralamaSutun,setSiralamaSutun] = useState("risk_skoru");
    const [siralamaYon,  setSiralamaYon]   = useState("asc");  // küçükten büyüğe
    const [kaliteMin,     setKaliteMin]     = useState(0);
    const [kaliteMax,     setKaliteMax]     = useState(100);
    const [riskMin,       setRiskMin]       = useState(0);
    const [riskMax,       setRiskMax]       = useState(100);
    const [makroVetoFiltre,  setMakroVetoFiltre]  = useState("HEPSI"); // HEPSI | VAR | YOK
    const [riskSeviyesiFiltre,setRiskSeviyesiFiltre] = useState("HEPSI");
    const [durumFiltre,      setDurumFiltre]      = useState("HEPSI"); // HEPSI | GECTI | ELENDI
    const pollRef      = useRef(null);
    const taramaBasRef = useRef(null);
    const saniyeRef    = useRef(null);

    useEffect(() => {
        portfoyYukle();
        riskSonuclarYukle();
    }, [mod]);

    useEffect(() => () => {
        if (pollRef.current)   clearInterval(pollRef.current);
        if (saniyeRef.current) clearInterval(saniyeRef.current);
    }, []);

    async function portfoyYukle() {
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/portfoy/liste?mod=${mod}&durum=ACIK`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setPortfoy(res.data);
        } catch (e) {
            console.warn("Portföy yüklenemedi:", e.message);
        }
    }

    async function riskSonuclarYukle(dogrudan=null) {
        // dogrudan: tarama bitince _rf_durum["sonuc"] içindeki veriyi direkt al
        if (dogrudan) {
            setRiskSonuclar({ toplam: dogrudan.toplam, sonuclar: dogrudan.sonuclar || [] });
            return;
        }
        try {
            const token = await getToken();
            const res = await axios.get(`${API_URL}/scan/risk-filtresi/sonuclar?mod=${mod}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setRiskSonuclar(res.data);
        } catch (e) {
            console.warn("Risk sonuçları yüklenemedi:", e.message);
        }
    }

    async function pozisyonSil(id) {
        if (!window.confirm("Bu pozisyonu silmek istiyor musunuz?")) return;
        try {
            const token = await getToken();
            await axios.delete(`${API_URL}/scan/portfoy/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Pozisyon silindi.");
            portfoyYukle();
        } catch (e) {
            toast.error("Hata: " + (e.response?.data?.detail || e.message));
        }
    }

    async function riskTaramaBaslat() {
        if (riskCalisiyor) return;
        setRiskCalisiyor(true);
        setGecenSure(0);
        setTaramaDurum({ ilerleme: 0, mesaj: "Başlatılıyor...", tamamlanan: 0, toplam: 0 });
        taramaBasRef.current = Date.now();

        // Saniye saniye gecen sure
        if (saniyeRef.current) clearInterval(saniyeRef.current);
        saniyeRef.current = setInterval(() => {
            setGecenSure(Math.round((Date.now() - taramaBasRef.current) / 1000));
        }, 1000);

        try {
            const token = await getToken();
            const baslat = await axios.post(`${API_URL}/scan/risk-filtresi/toplu-tara`,
                { mod },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            // Backend "ok: false" döndürdüyse (sembol bulunamadı vb.)
            if (baslat.data?.ok === false) {
                clearInterval(saniyeRef.current);
                setRiskCalisiyor(false);
                setTaramaDurum(null);
                toast.error(baslat.data.mesaj || "Tarama başlatılamadı.");
                return;
            }

            if (pollRef.current) clearInterval(pollRef.current);
            pollRef.current = setInterval(async () => {
                try {
                    const t   = await getToken();
                    const res = await axios.get(`${API_URL}/scan/risk-filtresi/durum`, {
                        headers: { Authorization: `Bearer ${t}` }
                    });
                    const d = res.data;

                    // mesaj formatı: "i/toplam|sembol"
                    const parca      = (d.mesaj || "").split("|");
                    const tamamlanan = parca.length === 2 ? parseInt(parca[0]?.split("/")[0]) || 0 : 0;
                    const toplam     = parca.length === 2 ? parseInt(parca[0]?.split("/")[1]) || 0 : 0;

                    setTaramaDurum({
                        ilerleme: d.ilerleme || 0,
                        mesaj:    d.mesaj    || "",
                        tamamlanan,
                        toplam,
                    });

                    if (!d.calisiyor) {
                        clearInterval(pollRef.current);
                        clearInterval(saniyeRef.current);
                        setRiskCalisiyor(false);
                        setTaramaDurum(null);
                        if (d.hata) {
                            toast.error("Tarama hatası: " + d.hata);
                        } else {
                            toast.success(`Risk taraması tamamlandı — ${d.sonuc?.toplam || 0} sembol.`);
                            setAktifSekme("risk");
                            // Önce direkt _rf_durum["sonuc"] içindeki veriyi kullan
                            if (d.sonuc?.sonuclar?.length > 0) {
                                riskSonuclarYukle(d.sonuc);
                            } else {
                                riskSonuclarYukle();
                            }
                        }
                    }
                } catch {}
            }, 2000);
        } catch (e) {
            clearInterval(saniyeRef.current);
            toast.error("Risk taraması başlatılamadı: " + e.message);
            setRiskCalisiyor(false);
            setTaramaDurum(null);
        }
    }


    const pozisyonlar = portfoy?.pozisyonlar || [];
    const ozet        = portfoy?.ozet || {};
    // riskSonuclar = { toplam, sonuclar: [...] }
    const riskListesi = (riskSonuclar?.sonuclar || [])
        .filter(r => !aramaMetni || r.symbol?.toLowerCase().includes(aramaMetni.toLowerCase()))
        .filter(r => {
            const kalite = parseFloat(r.kalite_skoru) || 0;
            return kalite >= kaliteMin && kalite <= kaliteMax;
        })
        .filter(r => {
            const risk = parseFloat(r.risk_skoru) || 0;
            return risk >= riskMin && risk <= riskMax;
        })
        .filter(r => {
            if (makroVetoFiltre === "HEPSI") return true;
            const veto = r.makro_veto === true || r.makro_veto === "true";
            return makroVetoFiltre === "VAR" ? veto : !veto;
        })
        .filter(r => riskSeviyesiFiltre === "HEPSI" || riskEtiket(parseFloat(r.risk_skoru)) === riskSeviyesiFiltre)
        .filter(r => {
            if (durumFiltre === "HEPSI") return true;
            return durumFiltre === "ELENDI" ? !!r.elendi_sebep : !r.elendi_sebep;
        })
        .sort((a, b) => {
            const col = siralamaSutun;
            let va = a[col], vb = b[col];
            // Sayısal kolonlar
            if (col !== "symbol" && col !== "durum" && col !== "elendi_sebep") {
                va = parseFloat(va) || 0;
                vb = parseFloat(vb) || 0;
            }
            if (va < vb) return siralamaYon === "asc" ? -1 :  1;
            if (va > vb) return siralamaYon === "asc" ?  1 : -1;
            return 0;
        });

    function toggleSiralama(sutun) {
        if (siralamaSutun === sutun) {
            setSiralamaYon(v => v === "asc" ? "desc" : "asc");
        } else {
            setSiralamaSutun(sutun);
            setSiralamaYon("asc");
        }
    }

    function SiralamaOku({ sutun }) {
        if (siralamaSutun !== sutun) return <span style={{ color: C.border, marginLeft: 3 }}>⇅</span>;
        return <span style={{ color: C.accent, marginLeft: 3 }}>{siralamaYon === "asc" ? "↑" : "↓"}</span>;
    }

    const drawdownRenk = (pct) => {
        if (pct < 5)  return C.bullish;
        if (pct < 10) return C.gold;
        if (pct < 20) return C.orange;
        return C.bearish;
    };

    return (
        <div style={{ padding: 24, background: C.bg, minHeight: "100vh", color: C.text, fontFamily: "system-ui,sans-serif" }}>
            {kapatmaPopup && (
                <KapatmaPopup
                    pozisyon={kapatmaPopup}
                    onKapat={() => { setKapatmaPopup(null); portfoyYukle(); }}
                    onIptal={() => setKapatmaPopup(null)}
                />
            )}
            {riskDetay && <RiskDetayPopup sonuc={riskDetay} onKapat={() => setRiskDetay(null)} />}

            {/* Başlık */}
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
                <span style={{fontSize:32}}>🛡️</span>
                <div>
                    <h1 style={{margin:0,fontSize:22,fontWeight:800,color:C.text}}>Risk Dashboard</h1>
                    <p style={{ margin: 0, fontSize: 13, color: C.muted }}>
                        Portföy yönetimi · İki katmanlı risk filtresi · {mod}
                    </p>
                </div>
            </div>

            {/* Kontrol Barı */}
            <div style={{
                display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap", alignItems: "center",
                opacity: riskCalisiyor ? 0.5 : 1, pointerEvents: riskCalisiyor ? "none" : "auto", transition: "opacity 0.3s",
            }}>
                {["BIST", "Kripto"].map(m => (
                    <button key={m} onClick={() => setMod(m)} disabled={riskCalisiyor} style={{
                        padding: "8px 20px", borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: "pointer",
                        border: `2px solid ${mod === m ? C.bearish : C.border}`,
                        background: mod === m ? C.bearish + "22" : "transparent",
                        color: mod === m ? C.bearish : C.muted,
                    }}>{m}</button>
                ))}
                <div style={{ width: 1, height: 30, background: C.border }} />
                <button onClick={() => setFormAcik(v => !v)} disabled={riskCalisiyor} style={{
                    padding: "8px 18px", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer",
                    background: formAcik ? C.border : "linear-gradient(135deg,#16a34a,#0d9488)",
                    border: "none", color: "white",
                }}>
                    {formAcik ? "✕ Formu Kapat" : "➕ Pozisyon Ekle"}
                </button>
                <button onClick={riskTaramaBaslat} disabled={riskCalisiyor} style={{
                    padding: "8px 18px", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer",
                    background: riskCalisiyor ? C.border : "linear-gradient(135deg,#dc2626,#ea580c)",
                    border: "none", color: "white",
                }}>
                    {riskCalisiyor ? "⏳ Taranıyor..." : "🛡️ Risk Taraması Başlat"}
                </button>
                <button onClick={() => { portfoyYukle(); riskSonuclarYukle(); }} disabled={riskCalisiyor} style={{
                    padding: "8px 14px", borderRadius: 8, fontSize: 13, cursor: "pointer",
                    background: "transparent", border: `1px solid ${C.border}`, color: C.muted,
                }}>🔄 Yenile</button>
            </div>

            {/* Pozisyon Formu */}
            {formAcik && (
                <PozisyonFormu
                    mod={mod}
                    onKaydet={() => { setFormAcik(false); portfoyYukle(); }}
                    onIptal={() => setFormAcik(false)}
                />
            )}

            {/* ─── İLERLEME PANELİ ──────────────────────────────────────────── */}
            {riskCalisiyor && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10,
                    padding: "10px 16px", borderRadius: 8, background: "#422006", border: "1px solid #92400e" }}>
                    <span style={{ fontSize: 16 }}>⚠️</span>
                    <span style={{ fontSize: 13, color: "#fde68a", fontWeight: 600 }}>
                        Tarama tamamlanıncaya kadar sayfayı kapatmayın
                    </span>
                </div>
            )}
            {riskCalisiyor && taramaDurum && (
                <RiskTaramaIlerlemePaneli durum={taramaDurum} gecenSure={gecenSure} mod={mod} />
            )}

            {/* Özet Kartlar */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 24 }}>
                {[
                    { baslik: "Açık Pozisyon", deger: ozet.acik_pozisyon_sayisi ?? "—", renk: C.accent, ikon: "📋" },
                    { baslik: "Toplam Değer",
                      deger: ozet.toplam_deger
                        ? ozet.toplam_deger.toLocaleString("tr-TR", { maximumFractionDigits: 0 }) + (mod === "BIST" ? " ₺" : " $")
                        : "—",
                      renk: C.gold, ikon: "💰" },
                    { baslik: "Drawdown",
                      deger: ozet.drawdown_pct != null ? `%${(parseFloat(ozet.drawdown_pct)||0).toFixed(2)}` : "—",
                      renk: drawdownRenk(ozet.drawdown_pct || 0), ikon: "📉", bilgi: "drawdown" },
                    { baslik: "Risk Taraması",
                      deger: riskSonuclar ? `${riskSonuclar.toplam ?? 0} sembol` : "—",
                      renk: C.teal, ikon: "🛡️", bilgi: "risk_analizi_sekme" },
                ].map(({ baslik, deger, renk, ikon, bilgi }) => (
                    <div key={baslik} style={{
                        background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, padding: 16,
                    }}>
                        <div style={{ fontSize: 11, color: C.muted, marginBottom: 6 }}>
                            {ikon} {baslik}{bilgi && <BilgiIkonu karti={bilgi} />}
                        </div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: renk }}>{deger}</div>
                    </div>
                ))}
            </div>

            {/* Sekme Seçici */}
            <div style={{ display: "flex", gap: 0, marginBottom: 20, background: C.panel, borderRadius: 10, padding: 4, width: "fit-content", border: `1px solid ${C.border}` }}>
                {[["portfoy", "📋 Portföyüm", null], ["risk", "🛡️ Risk Analizi", "risk_analizi_sekme"]].map(([key, label, bilgi]) => (
                    <button key={key} onClick={() => setAktifSekme(key)} style={{
                        padding: "7px 20px", borderRadius: 7, fontWeight: 700, fontSize: 13, cursor: "pointer",
                        border: "none",
                        background: aktifSekme === key ? C.accent + "33" : "transparent",
                        color: aktifSekme === key ? C.accent : C.muted,
                    }}>{label}{bilgi && <BilgiIkonu karti={bilgi} />}</button>
                ))}
            </div>

            {/* ─── SEKME: PORTFÖY ─────────────────────────────────────────────── */}
            {aktifSekme === "portfoy" && (
                <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "hidden" }}>
                    <div style={{ padding: "14px 20px", borderBottom: `1px solid ${C.border}`, background: C.bg,
                        display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontSize: 15, fontWeight: 700 }}>Açık Pozisyonlar</span>
                            <span style={{ fontSize: 12, color: C.muted }}>— {pozisyonlar.length} adet</span>
                        </div>
                    </div>
                    {pozisyonlar.length === 0 ? (
                        <div style={{ padding: 48, textAlign: "center", color: C.muted }}>
                            <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                            <div>Henüz açık pozisyon yok.</div>
                            <div style={{ fontSize: 12, marginTop: 6 }}>Yukarıdaki "Pozisyon Ekle" butonunu kullanın.</div>
                        </div>
                    ) : (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr style={{ background: C.bg }}>
                                        {["Sembol", "Sektör", "Yön", "Giriş", "Miktar", "Değer", "Stop", "Hedef", "İşlem"].map(h => (
                                            <th key={h} style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, color: C.muted, fontWeight: 700, whiteSpace: "nowrap" }}>
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pozisyonlar.map((p, i) => {
                                        const yon = p.yon === "ALIŞ" ? C.bullish : C.bearish;
                                        return (
                                            <tr key={p.id} style={{
                                                borderBottom: `1px solid ${C.border}`,
                                                background: i % 2 === 0 ? "transparent" : C.bg + "88",
                                            }}>
                                                <td style={{ padding: "10px 12px", fontWeight: 700, color: C.accent }}>{p.symbol}</td>
                                                <td style={{ padding: "10px 12px", color: C.muted, fontSize: 12 }}>{p.sektor || "—"}</td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <span style={{ color: yon, fontWeight: 700, fontSize: 12 }}>
                                                        {p.yon === "ALIŞ" ? "▲" : "▼"} {p.yon}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 12px", color: C.text, fontWeight: 600 }}>
                                                    {parseFloat(p.giris_fiyati).toLocaleString("tr-TR", { minimumFractionDigits: 2 })}
                                                </td>
                                                <td style={{ padding: "10px 12px", color: C.muted }}>
                                                    {parseFloat(p.miktar).toLocaleString("tr-TR")}
                                                </td>
                                                <td style={{ padding: "10px 12px", color: C.gold, fontWeight: 600 }}>
                                                    {parseFloat(p.toplam_deger || 0).toLocaleString("tr-TR", { maximumFractionDigits: 0 })}
                                                </td>
                                                <td style={{ padding: "10px 12px", color: C.bearish, fontSize: 12 }}>
                                                    {p.stop_fiyati ? parseFloat(p.stop_fiyati).toFixed(2) : "—"}
                                                </td>
                                                <td style={{ padding: "10px 12px", color: C.bullish, fontSize: 12 }}>
                                                    {p.hedef_fiyati ? parseFloat(p.hedef_fiyati).toFixed(2) : "—"}
                                                </td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <div style={{ display: "flex", gap: 6 }}>
                                                        <button onClick={() => setKapatmaPopup(p)} style={{
                                                            padding: "4px 10px", borderRadius: 6, fontSize: 11, cursor: "pointer",
                                                            background: C.bearish + "22", border: `1px solid ${C.bearish}44`,
                                                            color: C.bearish, fontWeight: 600,
                                                        }}>Kapat</button>
                                                        <button onClick={() => pozisyonSil(p.id)} style={{
                                                            padding: "4px 10px", borderRadius: 6, fontSize: 11, cursor: "pointer",
                                                            background: C.border, border: "none", color: C.muted,
                                                        }}>Sil</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}

            {/* ─── SEKME: RİSK ANALİZİ ────────────────────────────────────────── */}
            {aktifSekme === "risk" && (
                <div style={{ background: C.panel, border: `1px solid ${C.border}`, borderRadius: 12, overflow: "visible" }}>
                    <div style={{ padding: "14px 20px", borderBottom: `1px solid ${C.border}`, background: C.bg,
                        display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontSize: 15, fontWeight: 700 }}>Risk Filtresi Sonuçları</span>
                            <span style={{ fontSize: 12, color: C.muted }}>— {riskListesi.length} sembol</span>
                        </div>
                        <input
                            type="text" value={aramaMetni} onChange={e => setAramaMetni(e.target.value)}
                            placeholder="Sembol ara..."
                            style={{
                                padding: "6px 12px", borderRadius: 8, fontSize: 13,
                                background: C.bg, border: `1px solid ${C.border}`,
                                color: C.text, width: 180, outline: "none",
                            }}
                        />
                    </div>

                    {/* Filtre Kartı */}
                    <div style={{
                        padding: "14px 20px", borderBottom: `1px solid ${C.border}`,
                        display: "flex", flexWrap: "wrap", gap: 18, alignItems: "flex-end",
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                KALİTE<BilgiIkonu karti="kalite" />
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <input type="number" min={0} max={100} value={kaliteMin}
                                    onChange={e => setKaliteMin(Math.min(Number(e.target.value), kaliteMax))}
                                    style={{ width: 56, padding: "5px 8px", borderRadius: 6, fontSize: 12,
                                        background: C.bg, border: `1px solid ${C.border}`, color: C.text, outline: "none" }} />
                                <span style={{ color: C.muted, fontSize: 12 }}>–</span>
                                <input type="number" min={0} max={100} value={kaliteMax}
                                    onChange={e => setKaliteMax(Math.max(Number(e.target.value), kaliteMin))}
                                    style={{ width: 56, padding: "5px 8px", borderRadius: 6, fontSize: 12,
                                        background: C.bg, border: `1px solid ${C.border}`, color: C.text, outline: "none" }} />
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                RİSK SKORU<BilgiIkonu karti="risk_skoru" />
                            </span>
                            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <input type="number" min={0} max={100} value={riskMin}
                                    onChange={e => setRiskMin(Math.min(Number(e.target.value), riskMax))}
                                    style={{ width: 56, padding: "5px 8px", borderRadius: 6, fontSize: 12,
                                        background: C.bg, border: `1px solid ${C.border}`, color: C.text, outline: "none" }} />
                                <span style={{ color: C.muted, fontSize: 12 }}>–</span>
                                <input type="number" min={0} max={100} value={riskMax}
                                    onChange={e => setRiskMax(Math.max(Number(e.target.value), riskMin))}
                                    style={{ width: 56, padding: "5px 8px", borderRadius: 6, fontSize: 12,
                                        background: C.bg, border: `1px solid ${C.border}`, color: C.text, outline: "none" }} />
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                MAKRO VETO<BilgiIkonu karti="makro_veto" />
                            </span>
                            <div style={{ display: "flex", gap: 6 }}>
                                {[["HEPSI", "Hepsi", C.accent], ["VAR", "🚫 Var", C.bearish], ["YOK", "✓ Yok", C.bullish]].map(([key, label, renk]) => (
                                    <button key={key} onClick={() => setMakroVetoFiltre(key)} style={{
                                        padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer", fontWeight: 600,
                                        border: `1px solid ${makroVetoFiltre === key ? renk : C.border}`,
                                        background: makroVetoFiltre === key ? renk + "22" : "transparent",
                                        color: makroVetoFiltre === key ? renk : C.muted,
                                    }}>{label}</button>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>
                                RİSK SEVİYESİ<BilgiIkonu karti="risk_seviyesi" />
                            </span>
                            <select value={riskSeviyesiFiltre} onChange={e => setRiskSeviyesiFiltre(e.target.value)}
                                style={{ padding: "6px 10px", borderRadius: 6, fontSize: 12,
                                    background: C.bg, border: `1px solid ${C.border}`, color: C.text, outline: "none", cursor: "pointer" }}>
                                <option value="HEPSI">Hepsi</option>
                                <option value="Çok Düşük">Çok Düşük</option>
                                <option value="Düşük">Düşük</option>
                                <option value="Orta">Orta</option>
                                <option value="Yüksek">Yüksek</option>
                                <option value="Çok Yüksek">Çok Yüksek</option>
                            </select>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <span style={{ fontSize: 11, color: C.muted, fontWeight: 600, letterSpacing: "0.05em" }}>DURUM</span>
                            <div style={{ display: "flex", gap: 6 }}>
                                {[["HEPSI", "Hepsi", C.accent], ["GECTI", "✓ Geçti", C.bullish], ["ELENDI", "✗ Elendi", C.bearish]].map(([key, label, renk]) => (
                                    <button key={key} onClick={() => setDurumFiltre(key)} style={{
                                        padding: "5px 12px", borderRadius: 6, fontSize: 12, cursor: "pointer", fontWeight: 600,
                                        border: `1px solid ${durumFiltre === key ? renk : C.border}`,
                                        background: durumFiltre === key ? renk + "22" : "transparent",
                                        color: durumFiltre === key ? renk : C.muted,
                                    }}>{label}</button>
                                ))}
                            </div>
                        </div>
                    </div>
                    {riskListesi.length === 0 ? (
                        <div style={{ padding: 48, textAlign: "center", color: C.muted }}>
                            <div style={{ fontSize: 32, marginBottom: 8 }}>🛡️</div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 6 }}>
                                {riskCalisiyor ? "Tarama devam ediyor..." : "Risk taraması henüz çalıştırılmadı."}
                            </div>
                            {!riskCalisiyor && (
                                <div style={{ fontSize: 13 }}>"Risk Taraması Başlat" butonunu kullanın.</div>
                            )}
                        </div>
                    ) : (
                        <div style={{ overflowX: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr style={{ background: C.bg }}>
                                        {[
                                            { label: "Hisse",        sutun: "symbol",       bilgi: null },
                                            { label: "Kalite",       sutun: "kalite_skoru", bilgi: "kalite" },
                                            { label: "Makro Veto",   sutun: "makro_veto",   bilgi: "makro_veto" },
                                            { label: "Risk Skoru",   sutun: "risk_skoru",   bilgi: "risk_skoru" },
                                            { label: "Risk Seviyesi",sutun: "risk_skoru",   bilgi: "risk_seviyesi" },
                                            { label: "Etki",         sutun: "final_risk_etki", bilgi: "etki" },
                                            { label: "Durum",        sutun: "elendi_sebep", bilgi: null },
                                            { label: "Detay",        sutun: null,           bilgi: null },
                                        ].map(({ label, sutun, bilgi }) => (
                                            <th key={label}
                                                onClick={sutun ? () => toggleSiralama(sutun) : undefined}
                                                style={{
                                                    padding: "10px 12px", textAlign: "left", fontSize: 11,
                                                    color: siralamaSutun === sutun ? C.accent : C.muted,
                                                    fontWeight: 700, whiteSpace: "nowrap",
                                                    cursor: sutun ? "pointer" : "default",
                                                    userSelect: "none",
                                                }}>
                                                {label}
                                                {sutun && <SiralamaOku sutun={sutun} />}
                                                {bilgi && <BilgiIkonu karti={bilgi} />}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {riskListesi
                                        .map((r, i) => {
                                        const rr = riskRenk(parseFloat(r.risk_skoru));
                                        return (
                                            <tr key={r.symbol + i} style={{
                                                borderBottom: `1px solid ${C.border}`,
                                                background: i % 2 === 0 ? "transparent" : C.bg + "88",
                                            }}>
                                                <td style={{ padding: "10px 12px", fontWeight: 700, color: C.accent }}>{r.symbol}</td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                        <MiniBar deger={parseFloat(r.kalite_skoru)||0} renk={(r.kalite_gecti === true || r.kalite_gecti === 'true') ? C.bullish : C.bearish} />
                                                        <span style={{ color: (r.kalite_gecti === true || r.kalite_gecti === 'true') ? C.bullish : C.bearish, fontSize: 12, fontWeight: 600, minWidth: 28 }}>
                                                            {(parseFloat(r.kalite_skoru)||0).toFixed(0)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                                    {(r.makro_veto === true || r.makro_veto === 'true')
                                                        ? <span style={{ color: C.bearish, fontSize: 12, fontWeight: 700 }}>🚫 Veto</span>
                                                        : <span style={{ color: C.bullish, fontSize: 12 }}>✓</span>
                                                    }
                                                </td>
                                                <td style={{ padding: "10px 12px", minWidth: 130 }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                        <MiniBar deger={parseFloat(r.risk_skoru)||0} renk={rr} />
                                                        <span style={{ color: rr, fontWeight: 700, fontSize: 12, minWidth: 28 }}>
                                                            {(parseFloat(r.risk_skoru)||0).toFixed(0)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <span style={{
                                                        fontSize: 11, padding: "2px 8px", borderRadius: 10, fontWeight: 700,
                                                        background: rr + "22", color: rr,
                                                    }}>
                                                        {riskEtiket(parseFloat(r.risk_skoru))}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <span style={{ color: etki2Renk(parseFloat(r.final_risk_etki)), fontWeight: 700, fontSize: 13 }}>
                                                        {parseFloat(r.final_risk_etki)>0 ? "+" : ""}{(parseFloat(r.final_risk_etki)||0).toFixed(1)}
                                                    </span>
                                                </td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    {r.elendi_sebep
                                                        ? <span style={{ color: C.bearish, fontSize: 11, fontWeight: 700 }}>✗ Elendi</span>
                                                        : <span style={{ color: C.bullish, fontSize: 11, fontWeight: 700 }}>✓ Geçti</span>
                                                    }
                                                </td>
                                                <td style={{ padding: "10px 12px" }}>
                                                    <button onClick={() => setRiskDetay(r)} style={{
                                                        padding: "4px 10px", borderRadius: 6, fontSize: 11, cursor: "pointer",
                                                        background: C.accent + "22", border: `1px solid ${C.accent}44`,
                                                        color: C.accent, fontWeight: 600,
                                                    }}>Detay</button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
